// src/lib/Newsletters/NewsletterDashboard.tsx
import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import LoadingSpinner from '@/components/LoadingComponent';

interface NewsletterDashboardProps {
    newsletter: string;
}

const NewsletterDashboard: React.FC<NewsletterDashboardProps> = ({ newsletter }) => {
    const [dashboardUrl, setDashboardUrl] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchDashboardUrl = async () => {
            try {
                const user = JSON.parse(localStorage.getItem('user') || '{}');
                const response = await fetch(
                    `https://waffle-v2.thenewcc.workers.dev/newsletters/dashboard/${newsletter}`,
                    {
                        headers: {
                            'Authorization': `Bearer ${user.token}`
                        }
                    }
                );

                if (!response.ok) {
                    throw new Error('Falha ao carregar dashboard');
                }

                const data = await response.json();
                setDashboardUrl(data.url);
            } catch (error) {
                console.error('Erro ao carregar URL do dashboard:', error);
                setError('Erro ao carregar dashboard');
            } finally {
                setLoading(false);
            }
        };

        if (newsletter !== 'todos') {
            fetchDashboardUrl();
        }
    }, [newsletter]);

    if (newsletter === 'todos') return null;
    if (loading) return <LoadingSpinner />;
    if (error) return <div className="text-red-500">{error}</div>;
    if (!dashboardUrl) return null;

    return (
        <Card>
            <CardHeader>
                <CardTitle>Dashboard Detalhado</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="w-full aspect-[16/9]">
                    <iframe
                        src={dashboardUrl + '&subscription_created_at=past7days~'}
                        frameBorder="0"
                        className="w-full h-full"
                        allowFullScreen
                    />
                </div>
            </CardContent>
        </Card>
    );
};

export default NewsletterDashboard;